var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "global-modal",
        "hide-footer": "",
        "hide-header": "",
        centered: "",
        size: _vm.size,
      },
      on: { hidden: _vm.onHidden },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        _vm.component,
        _vm._b({ tag: "component" }, "component", _vm.props, false)
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }